import {
  EventRegistrationForm_OnlineInfoFragment,
  EventRegistrationForm_ViewerFragment,
  EventRegistrationFormFragment,
} from './__generated__/Event.graphql';
import RegistrationFormBareViewer from './RegistrationForm.BareViewer';
import RegistrationFormGuestViewer from './RegistrationForm.GuestViewer';
import RegistrationFormLoggedInViewer from './RegistrationForm.LoggedInViewer';
import RegistrationFormMustSignup from './RegistrationForm.MustSignup';
import RegistrationFormRegistered, {
  EventExtraDataProps,
} from './RegistrationForm.Registered';
import {EventState} from './useEventState';
import {
  GroupSessionPermission,
  GroupSessionRequestStatus,
} from '../../../__generated__/graphql/types';

import React from 'react';

export interface Props {
  readonly event: EventRegistrationFormFragment;
  readonly eventData: EventExtraDataProps;
  readonly eventState: EventState;
  readonly isRegistered: boolean;
  readonly onlineInfo: Maybe<EventRegistrationForm_OnlineInfoFragment>;
  readonly viewer: Maybe<EventRegistrationForm_ViewerFragment>;
  readonly isDisabled?: boolean;
  readonly registeredStatus?: GroupSessionRequestStatus;
}

export default function RegistrationForm(props: Props): JSX.Element {
  const {
    event,
    eventData,
    eventState,
    isDisabled,
    isRegistered,
    onlineInfo,
    registeredStatus,
    viewer,
  } = props;
  const eventID = event.id;

  if (isRegistered && registeredStatus) {
    return (
      <RegistrationFormRegistered
        event={event}
        eventExtraData={eventData}
        eventID={eventID}
        eventState={eventState}
        isDisabled={isDisabled}
        onlineInfo={onlineInfo}
        registeredStatus={registeredStatus}
      />
    );
  }

  if (viewer?.id == null) {
    if (event.permission == GroupSessionPermission.MemberOnly) {
      return <RegistrationFormMustSignup eventID={eventID} />;
    }

    return (
      <RegistrationFormGuestViewer
        eventID={eventID}
        isDisabled={isDisabled}
      />
    );
  }

  const publicProfile = viewer.publicProfile;
  const profileNotComplete =
    publicProfile?.id == null ||
    (publicProfile.profession?.id == null &&
      publicProfile.universityEducation?.id == null) ||
    publicProfile.biography?.id == null ||
    publicProfile.goal == null;

  if (profileNotComplete) {
    return <RegistrationFormBareViewer />;
  }

  return (
    <RegistrationFormLoggedInViewer
      eventID={eventID}
      isDisabled={isDisabled}
    />
  );
}
